import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProcessoAbas } from '../../../models/processo-abas.model';
import { ProcessoAbasService } from '../../../services/processo-abas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-abas-edit',
  templateUrl: './abas-edit.component.html',
  styleUrls: ['./abas-edit.component.scss'],
})
export class AbasEditComponent
  extends BaseFormComponent<ProcessoAbas>
  implements OnInit
{
  actionLabel: string = 'Nova';
  tiposList: Array<{ id: number; label: string }> = [];
  idProcesso: any;

  constructor(
    private myService: ProcessoAbasService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    private router: Router
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.loaded();
    this.tiposList = this.activatedRoute.snapshot.data.tiposList;

    if (this.entity) {
      this.idProcesso = this.entity.process_id;
    } else {
      let currentUrl = this.router.url;
      const regex = /processos\/(\d+)\/abas/;
      const match = currentUrl.match(regex);

      if (match) {
        this.idProcesso = match[1];
      } else {
        console.log('ID não encontrado');
      }
    }
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [
        Validators.required,
        Validators.maxLength(150),
      ]),
      process_id: new FormControl(''),
      type_id: new FormControl('', Validators.required),
    });

    this.form.get('type_id')?.setValue(this.tiposList[0].id);

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  voltar() {
    this.navigation.back([
      'pre-projeto/processos/' + this.idProcesso + '/abas',
    ]);
  }

  getDataCreate(): ProcessoAbas {
    let data: ProcessoAbas;
    data = Object.assign({}, data, this.form.value);
    data.process_id = this.idProcesso;
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService
            .update(this.getDataCreate(), this.entity?.id)
            .subscribe({
              next: (res: ProcessoAbas) => {
                this.msgSuccess('Cadastro alterado com sucesso!');
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ProcessoAbas) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace(['pre-projeto/processos/abas/', res.id]);
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace([
            'pre-projeto/processos/' + this.idProcesso + '/abas',
          ]);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }
}
